module.exports = __webpack_public_path__ + "static/media/space.eb74c218.png";